import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGame } from '../GameContext.tsx';
import { Stamp } from './Stamp.tsx';
import styles from './ApprovalStamp.module.css';

/** How long the stamp stays on the screen once it has come down. */
const STAY_MS = 1900;

/**
 * The plan is approved: APPROVED comes down on the screen with a thud (ART_BIBLE §8), as the
 * team goes in. It is shown for a moment and does not take the touches.
 */
export function ApprovalStamp() {
  const { t } = useTranslation('game');
  const { view } = useGame();
  const seen = useRef(
    Math.max(0, ...view.events.map((e) => (e.type === 'plan.approved' ? e.id : 0))),
  );
  const [shown, setShown] = useState(0);

  useEffect(() => {
    const newest = Math.max(0, ...view.events.map((e) => (e.type === 'plan.approved' ? e.id : 0)));
    if (newest > seen.current) {
      seen.current = newest;
      setShown((n) => n + 1);
    }
  }, [view.events]);

  useEffect(() => {
    if (shown === 0) return;
    const id = setTimeout(() => {
      setShown(0);
    }, STAY_MS);
    return () => {
      clearTimeout(id);
    };
  }, [shown]);

  if (shown === 0) return null;
  return (
    <div className={styles['layer']} key={shown} aria-hidden="true">
      <div className={styles['sheet']}>
        <Stamp tone="green" delay={0.05} tilt={-6} sound className={styles['stamp']}>
          {t('planning.stamp')}
        </Stamp>
      </div>
    </div>
  );
}
